import { map } from 'ramda'

import { RemoveOrgsParams } from 'app/dataTypes/org/orgGroup/orgsInside'

import { Request } from '../../../index'


type ParamsAPI = {
  school_ids: Array<number>
}

type UrlParams = {
  orgGroupID: number | string,
}

export const convertParams = ({ orgGroupID, orgIDs }: RemoveOrgsParams): [ParamsAPI, UrlParams] => {
  return ([{ school_ids: map(parseInt, orgIDs) }, { orgGroupID }])
}

export const convertResult = (result: string) => {
  return result === 'success'
}

export const POST_ORG_GROUP_REMOVE_ORGS: Request<RemoveOrgsParams, boolean, void> = [
  'food/school_groups/{orgGroupID}/remove_schools',
  'post',
  ['data', 'result'],
]
